import React from 'react';
import { JsonLd } from "react-schemaorg";
export default function VideoSchema(item, title, videoPoster, content) {
    if (content === void 0) { content = null; }
    return (React.createElement(JsonLd, { item: {
            "@context": "https://schema.org",
            '@type': 'VideoObject',
            contentUrl: item ? item : '',
            thumbnailUrl: videoPoster ? videoPoster : '',
            name: title ? title : '',
            description: content,
            publisher: {
                '@type': 'Organization',
                name: "Sky Lagoon",
            }
        } }));
}
